<template>
    <div class="bg-color" style="padding-top: 5px;padding-bottom: 10px;transition: none;">
        <div class="tab-bar">
            <el-tabs v-model="activeTabName" @tab-click="changeTab" >
                <el-tab-pane label="爬虫打码" name="spider_page" v-if="tabsList.includes('spider_page')"></el-tab-pane>
                <el-tab-pane label="媒体账户维护" name="plat_agent_page" v-if="tabsList.includes('plat_agent_page')"></el-tab-pane>
            </el-tabs>
        </div>
        <template v-if="isAllowed">
            <div class="page-wrap">
                <slot name="tab" :tab="activeTab"></slot>
            </div>
        </template>
        <template v-else>
            <NoPermissionInfo style="background-color: #fff;">
                <p>此页面可针对所有的媒体进行数据查询分析，覆盖全部维度与指标，灵活配置查询。</p>
            </NoPermissionInfo>
        </template>

    </div>

</template>

<script>
    import {mapGetters} from 'vuex';
    import NoPermissionInfo from '@/components/noPermissionInfo';

    export default {
        name: "TabPageWrap",
        components: {
            NoPermissionInfo,
        },
        props: {
            isAllowed: {
                required: true,
                type: Boolean,
            }
        },
        data() {
            return {
                activeTab: {
                    name: '',
                },
                activeTabName: 'data_all',
            }
        },
        computed: {
            ...mapGetters(['tabs_map']),
            tabsList() {
                let spiderPageTabs = this.tabs_map.spider_module || [];
                return spiderPageTabs.map(item => item.name);
            },
        },
        created() {
            let matchedRoute = this.$route.matched || [];
            this.activeTab = [...matchedRoute].reverse()[0];
            this.activeTabName = this.activeTab.name || '';
        },
        mounted() {

        },
        methods: {

            beforeChangeTab(newName){
                return new Promise((resolve, reject)=>{
                    this.$router.push(this.activeTabName);
                    this.$confirm('切换tab会导致当前筛选内容清空，确认要切换吗？', '温馨提示', {
                        confirmButtonText: '确认切换',
                        type: 'warning',
                        center: true,
                        showClose: false,
                        distinguishCancelAndClose: true,
                        closeOnPressEscape: false,
                    }).then(()=>{
                        this.activeTabName = newName;
                        this.$router.push(this.activeTabName);
                        this.$emit('change-tab');
                        resolve();
                    }).catch(()=>{
                        reject();
                    });
                });
            },
            changeTab(tab) {
                this.$router.push(tab.name);
                this.$emit('change-tab');
            },
        },
        beforeDestroy() {

        }

    }
</script>

<style lang="scss" scoped>
    .bg-color {
        background-color: #fff;
    }

    .page-wrap {
        display: flex;
        overflow: auto;
    }



    .bg-color-white {
        background-color: #fff;
    }

    ::v-deep .tab-bar .el-tabs__item {
        font-weight: bold;
    }

    ::v-deep .tab-bar .el-tabs__header {
        margin: 0 0 10px;
    }
</style>
